
export function handleLocalStateChange(name, value) {
  this.setState({
    [name]: value,
  });
}



// WEBPACK FOOTER //
// ./client/utils/react.js